import React from "react";

import RichText from "@src/components/elements/RichText";
import { getContentfulPreviewPropsFn } from "@src/utils";
import clsx from "clsx";

import { getImageSrc } from "./Card.utils";

const DefaultCard = ({ contentful_id, image, headline, body }) => {
  const getPreviewCardProps = getContentfulPreviewPropsFn(contentful_id);

  return (
    <div>
      {(image?.url || image?.file?.url) && (
        <img
          alt={image?.description || ""}
          className="w-[64px] h-auto mb-4"
          src={getImageSrc(image?.url ?? image.file.url)}
        />
      )}
      {headline && (
        <h4
          className={clsx("text-rt-l mb-6 leading-10")}
          {...getPreviewCardProps("headline")}
        >
          {headline}
        </h4>
      )}
      <div {...getPreviewCardProps("body")}>
        <RichText
          bodyRichText={
            !body?.json ? body : { raw: JSON.stringify(body?.json) }
          }
          classes={clsx("space-y-4")}
          useHeadings
        />
      </div>
    </div>
  );
};

export default DefaultCard;
